const SENTRY_ENVIRONMENTS = new Set(['staging', 'rc', 'prod'])

/**
 * Проверяет, нужно ли включать Sentry для текущего окружения.
 *
 * @param mode - режим запуска приложения
 * @returns `true` для staging, rc и production
 */
export const isSentryEnabled = (mode: string | undefined) =>
  Boolean(mode && SENTRY_ENVIRONMENTS.has(mode))
